import SetUserBasicDataModal from './SetUserBasicDataModal';
export default SetUserBasicDataModal;
